// deps
import { useContext, useMemo } from "react";

// contexts
import { CredEligiblityContext } from "@payment-client/contexts/CredEligiblityContext";
import { JuspayContext } from "@payment-client/contexts/JuspayContext";
import { CredEligibleData } from "@swiggy-private/payment-ui";

//helpers
import { getJuspaySdkFeatureAvailability } from "@payment-client/helpers/JuspayHelpers";
import { VALID_PAYMENT_GROUP_TYPES } from "@swiggy-private/payment-types";

export const useCredPayHandler = (): CredEligibleData => {
    const { isEligible, bannerText, isOfferLoading } = useContext(CredEligiblityContext);
    const juspayContext = useContext(JuspayContext);

    const isSdkAvailable = useMemo((): boolean => {
        return getJuspaySdkFeatureAvailability(
            VALID_PAYMENT_GROUP_TYPES.CRED,
            juspayContext.isSdkAvailable,
            juspayContext.featuresAvailability,
        );
    }, [juspayContext.featuresAvailability, juspayContext.isSdkAvailable]);

    return {
        isEligible,
        bannerText,
        isSdkAvailable,
        isOfferLoading,
    };
};
